import { useEffect, useState } from 'react';

const useText = (subjectId, unitId, items) => {
  const [text, setText] = useState('');

  const getShareableUrl = (providerId) =>
    `${FYM_FRONTEND_URL}/d/${providerId}?sui=${subjectId},${unitId}`;

  useEffect(() => {
    let newText;
    if (items.length === 1) {
      const [item] = items;
      const { url, providerVideoId } = item;
      newText = getShareableUrl(url || providerVideoId);
    } else {
      newText = '';
      items.forEach((item) => {
        const { displayName, url } = item;
        const shareableUrl = getShareableUrl(url);
        return (newText += `${displayName}\t${shareableUrl}\n`);
      });
    }

    setText(newText);
  }, [subjectId, unitId, items]);

  return text;
};

export default useText;
